/**
 * Toggle Mode Enum
 * Defines available toggle modes for the side navigation
 */
export enum ToggleMode {
  Customer = 'customer',
  Admin = 'admin',
}
